import parse from "html-react-parser";
import { get } from "lodash";
import { GetServerSidePropsContext, InferGetServerSidePropsType } from "next";
import { useEffect, useRef, useState } from "react";
import Accordion from "~/components/Accordion";
import Breadcrumb from "~/components/Breadcrumb";
import Container from "~/components/Container";
import SEOTags from "~/components/SEOTags";
import { Identifiers } from "~/constants/enum";
import { QUERY_GET_CMS_PAGE } from "~/data/cms/gql";
import Layout from "~/layouts/ThemeLayout";
import { initializeSSRApollo } from "~/utils/apollo-client";

const getText = (domNode: any) => {
  let text = "";
  domNode?.children?.forEach((child: any) => {
    if (child.type === "text") {
      text += child.data;
    } else {
      text += getText(child);
    }
  });
  return text;
};

const CmsPage = ({
  data,
  loading,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const faqRef = useRef<any>();
  const cmsPage = get(data, "cmsPage.content", "") as string;
  const [arrcodingData, setArrcodingData] = useState<any>([]);

  // const content = parse(cmsPage, {
  //     replace(domNode, index) {

  //     },
  // });

  const { meta_description, meta_title, meta_keywords, url_key, title } =
    data?.cmsPage || {};

  const parsedHtml: any = parse(cmsPage);
  let output: any = [];

  // parsedHtml?.props?.children.forEach((li:any) => {
  //     // const question = li.props.children[0].props.children;
  //     // const answer = li.props.children[1].props.children;
  //     output.push({
  //         question: li,
  //         // answers: [{ answer: answer.trim() }]
  //     });
  // });

  // const jsonOutput = JSON.stringify(output, null, 4);

  const initAccordion = () => {
    setTimeout(() => {
      const accordionItems: any =
        faqRef?.current?.getElementsByClassName("accordion__item");
      const ArrayArrcoding = [];
      for (let index = 0; index < accordionItems.length; index++) {
        const element = accordionItems[index];
        const question: any =
          element?.getElementsByClassName("accordion__button")?.[0]?.innerHTML;
        if (!!question) {
          const panels: any =
            element?.getElementsByClassName("accordion__panel")?.[0];
          ArrayArrcoding.push({
            label: question,
            content: <div>{!!panels ? parse(panels?.innerHTML) : ""}</div>,
            key: index,
          });
        }
      }
      setArrcodingData(ArrayArrcoding);
    }, 100);
  };

  useEffect(() => {
    initAccordion();
  }, [cmsPage]);

  return (
    <Layout className="flex flex-col ">
      <SEOTags
        title={meta_title}
        description={meta_description}
        keywords={meta_keywords}
        url={url_key}
      />
      <Container
        rootClassName="py-10 lg:py-16 lg:pt-3"
        className="flex flex-col gap-8 cms-page flex-1 "
      >
        <Breadcrumb items={[{ title: "Home", path: "/" }, { title: title }]} />
        <div
          ref={faqRef}
          className="hidden"
          dangerouslySetInnerHTML={{ __html: cmsPage }}
        />

        <Accordion className="pb-5" items={arrcodingData} />
      </Container>
    </Layout>
  );
};

export default CmsPage;

export async function getServerSideProps({
  params,
}: GetServerSidePropsContext) {
  const { cmsPage: uri } = params || {};
  const apolloClient = initializeSSRApollo({
    httpLinkProps: { useGETForQueries: true },
  });

  let res = {} as CmsPageProps;
  try {
    res = await apolloClient.query({
      query: QUERY_GET_CMS_PAGE,
      variables: {
        identifier: Identifiers.FAQ,
      },
      context: { fetchOptions: { method: "GET" } },
    });
  } catch (error) {
    console.error(error, "QUERY_SEO_CATEGORY");
  }

  return { props: { ...res } };
}
